import React from 'react';
import { VehicleType } from '../types';
import { 
  PickupTruckIcon, 
  DualWheelPickupIcon, 
  RabonTruckIcon, 
  TortonTruckIcon, 
  SingleTrailer2AxlesIcon,
  SingleTrailer3AxlesIcon,
  Full6AxlesIcon,
  Full7AxlesIcon,
  Full8AxlesIcon,
  Full9AxlesIcon
} from './VehicleIcons';

interface VehicleIconProps {
  type: VehicleType;
  size?: number;
  className?: string;
}

const VehicleIcon: React.FC<VehicleIconProps> = ({ 
  type, 
  size = 48,
  className = ""
}) => {
  switch (type) {
    case VehicleType.PICKUP_TRUCK:
      return <PickupTruckIcon size={size} className={className} />;
      
    case VehicleType.DUAL_WHEEL_PICKUP:
      return <DualWheelPickupIcon size={size} className={className} />;
      
    case VehicleType.RABON:
      return <RabonTruckIcon size={size} className={className} />;
      
    case VehicleType.TORTON:
      return <TortonTruckIcon size={size} className={className} />;
      
    case VehicleType.SINGLE_WITH_2_AXLE_TRAILER:
      return <SingleTrailer2AxlesIcon size={size} className={className} />;
      
    case VehicleType.SINGLE_WITH_3_AXLE_TRAILER:
      return <SingleTrailer3AxlesIcon size={size} className={className} />;
      
    case VehicleType.FULL_6_AXLES:
      return <Full6AxlesIcon size={size} className={className} />;
      
    case VehicleType.FULL_7_AXLES:
      return <Full7AxlesIcon size={size} className={className} />;
      
    case VehicleType.FULL_8_AXLES:
      return <Full8AxlesIcon size={size} className={className} />;
      
    case VehicleType.FULL_9_AXLES:
      return <Full9AxlesIcon size={size} className={className} />;
      
    default:
      return <TortonTruckIcon size={size} className={className} />;
  }
};

export default VehicleIcon;